import { render, staticRenderFns } from "./pickUp.vue?vue&type=template&id=0e2e4c54&scoped=true&"
import script from "./pickUp.vue?vue&type=script&lang=js&"
export * from "./pickUp.vue?vue&type=script&lang=js&"
import style0 from "./pickUp.vue?vue&type=style&index=0&id=0e2e4c54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e4c54",
  null
  
)

export default component.exports